function RealGirlOnline() {
  return (
    <div>
      <h1>realgirl.online</h1>
      <img
        src="/assets/thumbnails/realgirl_online.png"
        alt="realgirl.online screenshot"
      />
      <p>
        <a href="https://realgirl.online">realgirl.online</a> is a webzine, an
        experiment in getting lost and finding myself again.
      </p>
    </div>
  );
}

export default RealGirlOnline;
